import { useEffect, useRef, useState } from 'react';
import { Confetti, type CelebrationStyle } from '@/components/ui/Confetti';
import { useSfx } from '@/lib/useSfx';
import { useHaptics } from '@/lib/haptics';
import { SOUND_NAMES, type SoundName } from '@/lib/sfx';

/** Mounted above routes so successful actions can celebrate after their modal closes. */
export function ActionCelebration() {
  const [trigger, setTrigger] = useState(0);
  const [variant, setVariant] = useState<CelebrationStyle>();
  const play = useSfx();
  const vibrate = useHaptics();
  const last = useRef(-Infinity);
  useEffect(() => {
    const celebrate = (event: Event) => {
      if (document.visibilityState === 'hidden' || Date.now() - last.current < 800) return;
      last.current = Date.now();
      const detail = (event as CustomEvent).detail;
      // Routine completions animate their toast icon; milestones keep the full celebration.
      const milestone = !detail?.kind || detail.kind === 'milestone';
      if (milestone) {
        setTrigger((value) => value + 1);
        setVariant(
          ['burst', 'fountain', 'sparkles'].includes(detail?.style) ? detail.style : undefined,
        );
      }
      play(SOUND_NAMES.includes(detail?.sound) ? (detail.sound as SoundName) : 'celebrate');
      vibrate(milestone ? 30 : 15);
    };
    window.addEventListener('finbob:celebrate', celebrate);
    return () => window.removeEventListener('finbob:celebrate', celebrate);
  }, [play, vibrate]);
  return <Confetti trigger={trigger} variant={variant} />;
}
